import React, { useState } from "react";
import styled from 'styled-components';

const FORM_ENDPOINT = "https://public.herotofu.com/v1/3caf8720-9be0-11ee-9dec-893a2542e245";

const FormContainer = styled.div`
  width: 100%;
`;

const StyledForm = styled.form`
  width: 100%;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const inputStyles = `
  width: 100%;
  padding: 14px 16px;
  background-color: rgba(31, 38, 46, 0.7);
  border: 1px solid rgba(76, 124, 113, 0.3);
  border-radius: 6px;
  font-size: 16px;
  color: white;
  font-family: var(--font-primary);
  box-sizing: border-box;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: var(--bg-secondary);
    box-shadow: 0 0 8px rgba(76, 124, 113, 0.5);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const Input = styled.input`
  ${inputStyles}
`;

const Textarea = styled.textarea`
  ${inputStyles}
  resize: none;
  height: 120px;
`;

const Button = styled.button`
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(
    135deg,
    var(--bg-secondary),
    var(--bg-tertiary)
  );
  color: white;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--font-primary);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: all 0.6s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: 20px;
  background: linear-gradient(
    145deg,
    rgba(76, 124, 113, 0.2),
    rgba(31, 38, 46, 0.9)
  );
  border-radius: 8px;
  border-left: 3px solid var(--bg-secondary);
  
  p {
    font-family: var(--font-primary);
    font-size: 1.2rem;
    color: white;
    margin: 0;
    background: linear-gradient(
      to right, 
      var(--bg-tertiary), 
      var(--bg-secondary) 50%, 
      white 75%
    );
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine 4s linear infinite;
  }
`;

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });
      
      if (response.ok) {
        setSubmitted(true);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    }
  };

  if (submitted) {
    return (
      <SuccessMessage>
        <p>Thank you. We'll be in contact soon!</p>
      </SuccessMessage>
    );
  }

  return (
    <FormContainer>
      <StyledForm
        action={FORM_ENDPOINT}
        method="POST"
        onSubmit={handleSubmit}
      >
        <FormContent>
          <Input type="text" placeholder="Your Name" name="name" required />
          <Input type="email" placeholder="Your Email" name="email" required />
          <Textarea placeholder="Tell us how we can help you" name="message" required></Textarea>
          <Button type="submit">Send Message</Button>
        </FormContent>
      </StyledForm>
    </FormContainer>
  );
};

export default ContactForm;
